// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import TutorialDataService from "../services/TutorialService";
//
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import tollPlazasService from '../../services/TollPlazasService';

const initialState = {
  plazas: [],
  fetchingPlazas: false
};

export const getPlazas = createAsyncThunk('tollPlaza/getAll', async (_, { rejectWithValue, fulfillWithValue }) => {
  return tollPlazasService
    .getAll()
    .then((res) =>
      fulfillWithValue({
        status: res.status,
        data: res.data
      })
    )
    .catch((err) => {
      return rejectWithValue({
        status: err.response.status,
        data: err.response.data
      });
    });
});

const tollPlaza = createSlice({
  name: 'tollPlaza',
  initialState,
  reducers: {},
  extraReducers: {
    [getPlazas.rejected]: (state) => {
      state.fetchingPlazas = false;
    },
    [getPlazas.pending]: (state) => {
      state.fetchingPlazas = true;
    },
    [getPlazas.fulfilled]: (state, action) => {
      state.fetchingPlazas = false;
      state.plazas = action.payload.data;
    }
  }
});

const { reducer } = tollPlaza;

export const {} = tollPlaza.actions;

export default reducer;
